import { createContext } from 'react';

interface TaskContext {
  taskId: string;
  rxId: string | null;
  onTaskUpdate: () => Promise<void>;
  updating: boolean;
  setUpdating: (value: boolean) => void;
}

export const TaskContext = createContext<TaskContext>({} as TaskContext);
